var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pin_-_yellow",
    "data-name": "Pin - yellow",
    transform: "translate(-493 -112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2949",
    "data-name": "Rectangle 2949",
    transform: "translate(493 112)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pin-svgrepo-com",
    d: "M16.729,4.271a.99.99,0,0,0-1.639.351,6.483,6.483,0,0,1-2.9,3.293A10.946,10.946,0,0,1,7,9a.99.99,0,0,0-.382.076,1,1,0,0,0-.541,1.305.99.99,0,0,0,.217.326L9.537,13.95,5,20l6.05-4.537L14.292,18.7a.975.975,0,0,0,.326.217A1,1,0,0,0,16,18a10.813,10.813,0,0,1,1.083-5.166,6.475,6.475,0,0,1,3.293-2.9A.983.983,0,0,0,20.73,9.7a1,1,0,0,0,0-1.414l-4-4.02Z",
    transform: "translate(489.99 110.012)",
    fill: "#feb832"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinYellow);
export default __webpack_public_path__ + "static/media/pin-yellow.d3d54fa30de3db590bb21ac95848c0a0.svg";
export { ForwardRef as ReactComponent };